import type { LcSelectListOption } from '@lottocom/frontend-components'

export const useStateSwitch = () => {
  const { t } = useI18n()
  const { currentRoute } = useRouter()
  const { hiddenLicensedTerritories, licensedTerritories, licensedTerritory } =
    useRuntimeConfig().public

  const isStateSwitchRedirectModalVisible = ref(false)

  const toStateSwitchOptions = (value: string): LcSelectListOption => {
    const [id, uri] = value.split(':')

    const state = t(`licensedterritory.${id}`)

    return {
      ariaLabelText: t('stateswitch.link.title', {
        state,
      }),
      href: `https://${uri}${currentRoute.value.path}?ts=${id}`,
      label: state,
      value: id,
    }
  }

  const filterHiddenLicensedTerritories = (value: string) =>
    !(hiddenLicensedTerritories.split(',') ?? []).includes(value.substring(0, 5))

  const options = computed(() =>
    licensedTerritories
      .split(',')
      .filter(filterHiddenLicensedTerritories)
      .map(toStateSwitchOptions),
  )

  return {
    isStateSwitchRedirectModalVisible,
    licensedTerritory,
    options,
  }
}
